<template>
  <section class="profile-section">
    <transition name="show" mode="out-in">
      <div v-if="loading" key="loading" class="profile-loading">
        <i class="fas fa-spinner loading-big"></i>
      </div>
      <UserDetail
        v-else-if="user && customer"
        key="content"
        change="dados"
        :customer="customer"
        :previousShows="previousShows"
        :nextShows="nextShows"
        :onlineShows="onlineShows"
      />
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { removeToken } from '../../util'
import UserDetail from './UserDetail.vue'
import { get } from '../api/customer'

export default {
  name: 'user',
  components: { UserDetail },
  props: ['type'],
  data () {
    return {
      loading: true,
      customer: null,
      nextShows: [],
      previousShows: [],
      onlineShows: []
    }
  },
  computed: {
    ...mapState(['user'])
  },
  watch: {
    async '$route' (value) {
      if (!value.params.change) {
        try {
          this.customer = await get()
        } catch (error) {
          logger.error(error, this)
        }
      }
    }
  },
  async mounted () {
    document.body.style.backgroundColor = '#0b0e11'
    try {
      if (!this.user) {
        this.$router.push('/')
        this.$store.commit('redirect', '/usuario')
        this.$store.commit('showLogin', true)
        return false
      }
      this.customer = await get()
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
  },
  methods: {
    signOut () {
      removeToken()
      this.$store.commit('user', null)
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.profile-section {
  min-height: calc(100vh - #{$menu-height});
}

.profile-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 320px;
  font-size: 2em;
}
</style>
